__turbopack_context__.v({
  "breadcrumbs": "Pe4rtq_breadcrumbs",
});
